/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_ScoreInputs */

const th_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติรวม`)
};

const en_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box score`)
};

const ja_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボックススコア`)
};

const zh_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术统计`)
};

const es_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas del partido`)
};

const pt_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas do jogo`)
};

const id_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik pertandingan`)
};

const fr_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feuille de match`)
};

const tl_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box score`)
};

const vi_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê trận`)
};

const ko_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기 기록`)
};

const de_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielstatistik`)
};

const ru_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика матча`)
};

const tr_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maç istatistiği`)
};

const it_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche della partita`)
};

const pl_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki meczu`)
};

const uk_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика матчу`)
};

const hi_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच के आँकड़े`)
};

const ar_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصاءات المباراة`)
};

const ms_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik perlawanan`)
};

const bn_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলার পরিসংখ্যান`)
};

const zh_tw2_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術統計`)
};

const zh_hk2_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術統計`)
};

const ur_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچ کے اعداد و شمار`)
};

const fa_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آمار بازی`)
};

const sw_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takwimu za mchezo`)
};

const nl_box_score = /** @type {(inputs: Box_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijdstatistieken`)
};

/**
* | output |
* | --- |
* | "Box score" |
*
* @param {Box_ScoreInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const box_score = /** @type {((inputs?: Box_ScoreInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_ScoreInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_box_score(inputs)
	if (locale === "ja") return ja_box_score(inputs)
	if (locale === "zh") return zh_box_score(inputs)
	if (locale === "es") return es_box_score(inputs)
	if (locale === "pt") return pt_box_score(inputs)
	if (locale === "id") return id_box_score(inputs)
	if (locale === "fr") return fr_box_score(inputs)
	if (locale === "tl") return tl_box_score(inputs)
	if (locale === "vi") return vi_box_score(inputs)
	if (locale === "ko") return ko_box_score(inputs)
	if (locale === "de") return de_box_score(inputs)
	if (locale === "ru") return ru_box_score(inputs)
	if (locale === "tr") return tr_box_score(inputs)
	if (locale === "it") return it_box_score(inputs)
	if (locale === "pl") return pl_box_score(inputs)
	if (locale === "uk") return uk_box_score(inputs)
	if (locale === "hi") return hi_box_score(inputs)
	if (locale === "ar") return ar_box_score(inputs)
	if (locale === "ms") return ms_box_score(inputs)
	if (locale === "bn") return bn_box_score(inputs)
	if (locale === "zh-TW") return zh_tw2_box_score(inputs)
	if (locale === "zh-HK") return zh_hk2_box_score(inputs)
	if (locale === "ur") return ur_box_score(inputs)
	if (locale === "fa") return fa_box_score(inputs)
	if (locale === "sw") return sw_box_score(inputs)
	if (locale === "nl") return nl_box_score(inputs)
	return en_box_score(inputs)
});